import { LanguageCode } from '@/interfaces/user.interface';
import { usePreferredLanguages } from '@vueuse/core';
import axios from 'axios';

export const engeniApi = axios.create({
  baseURL: import.meta.env.VITE_APP_ENGENI_API_URL,
});

// Add token to request
engeniApi.interceptors.request.use((request) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
});

// add locale query param to request only if it's not logged in
engeniApi.interceptors.request.use((request) => {
  const token = localStorage.getItem('access_token');

  if (!token) {
    // get preferred language from browser
    const preferredLanguages = usePreferredLanguages();

    const preferredLocale = Object.values(LanguageCode).find((lang) =>
      preferredLanguages.value.includes(lang),
    );
    request.params = {
      ...request.params,
      locale: preferredLocale || LanguageCode.ES,
    };
  }

  return request;
});

engeniApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.clear();
        window.location.reload();
      }
    } else {
      // Handle the case when error.response is undefined
      console.error('Error response is undefined:', error);
    }
    return Promise.reject(error);
  },
);
